import { render } from "./UITablesPage.vue?vue&type=template&id=25eaccfd&ts=true"
import script from "./UITablesPage.vue?vue&type=script&lang=ts"
export * from "./UITablesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__